import { useRenderAppActions } from "../../hooks/renderAppActions";
import { AppTable } from "../../types/app.type";
import AppActions from "../AppActions";

interface Props {
  app: AppTable;
}

function AppActionsCell({ app }: Props) {
  const renderAppActions = useRenderAppActions(app);

  if (!renderAppActions) return null;

  return (
    <div className='invisible group-hover:visible [&>button[data-state="open"]]:visible flex'>
      <AppActions app={app} />
    </div>
  );
}

export default AppActionsCell;
